document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("global-modal");
  const modalContent = modal ? modal.querySelector('.modal-content') : null;

  if (modal && modalContent) {
    // Add class for modal styling
    modal.classList.add("modal");

    // Add click event for modal open buttons
    document.querySelectorAll('[data-modal-open="global-modal"]').forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the modal content within the same block as the trigger
        const triggerBlock = button.closest('.product-collapse');
        if (triggerBlock) {
          const blockModalContent = triggerBlock.querySelector('.modal-content');
          console.log(blockModalContent);
          if (blockModalContent) {
            // Update the modal content
            modalContent.innerHTML = blockModalContent.innerHTML;
            modalContent.classList.add("modal-content-style");
          }
        }
        
        modal.classList.add("is-active");
        document.body.classList.add("no-scroll");
      });
    });

    // Add click event for modal close buttons
    modal.querySelectorAll("[data-modal-close]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        modal.classList.remove("is-active");
        document.body.classList.remove("no-scroll");
      });
    });

    // Close when clicking outside modal content
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        e.preventDefault();
        modal.classList.remove("is-active");
        document.body.classList.remove("no-scroll");
      }
    });

    // Close with ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("is-active")) {
        e.preventDefault();
        modal.classList.remove("is-active");
        document.body.classList.remove("no-scroll");
      }
    });
  }
});
